import styled from "styled-components"

export const TableBody = styled.tbody``

// TODO: Deprecate. Replace with GQL Type `SortDirection`
export enum SortOrder {
  Ascending = "Ascending",
  Descending = "Descending",
}
